/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { DOCUMENT } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { Placement } from "@ngx-popovers/core";
import { PopoverComponent, PopoverModule } from "@ngx-popovers/popover";

@Component({
	selector: "globalictcc-popover",
	standalone: true,
	imports: [PopoverModule],
	templateUrl: "./popover.component.html",
	styleUrl: "./popover.component.scss"
})
export class PopoverFloatingComponent {
	@Input() public placement: Placement = "bottom-start";

	private _isVisible: boolean = false;
	private readonly _document: Document = inject(DOCUMENT);

	/**
	 * Handles the click event outside of the popover component.
	 *
	 * @param element - The HTML element that was clicked.
	 * @param popover - The instance of the PopoverComponent.
	 *
	 * This method checks if the popover is visible and if the clicked element is outside
	 * the popover. If the popover is visible and the clicked element is outside the popover,
	 * it closes the popover.
	 */
	public onClickedOutside(element: Element, popover: PopoverComponent) {
		if (!this._isVisible) return;

		const cdkContainer: HTMLDivElement | null =
			this._document.querySelector(".cdk-overlay-container");

		if (
			!cdkContainer ||
			(cdkContainer && !cdkContainer.hasChildNodes()) ||
			(cdkContainer && cdkContainer.hasChildNodes() && !cdkContainer.contains(element))
		)
			popover.close();
	}

	/**
	 * Handles the click event inside the component.
	 * Closes the popover if the clicked element is a button or a globalictcc-button with a type of "submit".
	 *
	 * @param element - The DOM element that was clicked.
	 * @param popover - The PopoverComponent instance to be closed.
	 */
	public onClickedInside(element: Element, popover: PopoverComponent) {
		if (
			(element.tagName.toLowerCase() === "button" ||
				element.tagName.toLowerCase() === "globalictcc-button") &&
			element.getAttribute("type") === "submit"
		)
			popover.close();
	}

	/**
	 * Handles the visibility change of the popover component.
	 *
	 * @param isVisible - A boolean indicating whether the popover is visible.
	 */
	public onVisibilityChange(isVisible: boolean) {
		this._isVisible = isVisible;
	}
}
